module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("A Selection of Recent Titles by Susan Rogers Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Milt Kovak Series")])]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("THE MAN IN THE GREEN CHEVY")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("HOUSTON IN THE REARVIEW MIRROR")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("OTHER PEOPLE’S HOUSES")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("CHASING AWAY THE DEVIL")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("DEAD MOON ON THE RISE")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("DOCTORS AND LAWYERS AND SUCH")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("LYING WONDERS")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("VEGAS NERVE")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("SHOTGUN WEDDING *")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("RUDE AWAKENING *")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("HUSBAND AND WIVES *")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered-space-after"
  }, [_vm._v(" DARK WATERS *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The E J Pugh Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("ONE, TWO, WHAT DID DADDY DO?")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("HICKORY DICKORY STALK")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("HOME AGAIN, HOME AGAIN")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("THERE WAS A LITTLE GIRL")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("A CROOKED LITTLE HOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("NOT IN MY BACK YARD")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("DON’T DRINK THE WATER")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("ROMANCED TO DEATH *")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered"
  }, [_vm._v("FULL CIRCLE * ")]), _vm._v(" "), _c('p', {
    staticClass: "flush-centered-space-after"
  }, [_vm._v("DEAD WEIGHT *")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "display-centered"
  }, [_c('em', [_vm._v("*available from Severn House")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15742380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/alsoby.vue
// module id = 63
// module chunks = 0